import React, { useState } from 'react'
import { ResetPasswordForm } from '../components/auth/reset_password_form'
import { useNavigate, useParams } from 'react-router-dom'
import { axiosPost } from '../util/api'
import { Toasts } from '../components/toaster/Toast'

export const ResetPassword = () => {
    const { token } = useParams()
    const navigate = useNavigate()
    const email = getEmail()
    console.log('Props is', token, email)
    const [loading, setLoading] = useState(false)

    const reset = (password: string) => {
        setLoading(true)
        axiosPost(
            'password/reset',
            {
                token,
                password,
                password_confirmation: password,
                email,
            },
            true,
        )
            .then((res) => {
                setLoading(false)
                Toasts.success('Password change successful!')
                navigate('/dashboard')
            })
            .catch((res) => {
                setLoading(false)
                console.log(res)
            })
    }

    function getEmail() {
        const params = new URLSearchParams(location.search)

        return params.get('email')
    }

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <ResetPasswordForm onSubmit={reset} loading={loading} />
        </div>
    )
}
